import authService from "libs/authService";

export default function getHeader() {
  const token = authService.getCredential();

  if (!token) {
    return undefined;
  }

  return {
    accept: "*/*",
    "X-AUTH-TOKEN": token,
  };
}
